define('util/math',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isReal = exports.signum = exports.max = exports.min = void 0;
    // Has the nice property that min(3,NaN) = 3
    // Note: the reverse is not true. min(NaN,3) = NaN
    function min(a, b) { return a > b ? b : a; }
    exports.min = min;
    function max(a, b) { return a < b ? b : a; }
    exports.max = max;
    // Math.sign not in typescript
    function signum(x) {
        return x ? x < 0 ? -1 : 1 : 0;
    }
    exports.signum = signum;
    function isReal(x) {
        return x !== null && isFinite(x); // null is finite but undefined isn't
    }
    exports.isReal = isReal;
});
//# sourceMappingURL=/assets/javascripts/util/math.js.map;
